import { createSlice } from '@reduxjs/toolkit';

const assignFeeStructureToClassSlice = createSlice({
  name: 'assignedFeeStructureToClass',
  initialState: {
    assignedFeeStructureToClass: [],
    loading: false,
    error: null,
  },
  reducers: {
    getAssignedFeeStructureToCalssRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getAssignedFeeStructureToCalssSuccess: (state, action) => {
      state.loading = false;
      state.assignedFeeStructureToClass = action.payload;
    },
    getAssignedFeeStructureToCalssFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAssignedFeeStructureToCalss: state => {
      state.assignedFeeStructureToClass = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getAssignedFeeStructureToCalssRequest,
  getAssignedFeeStructureToCalssSuccess,
  getAssignedFeeStructureToCalssFailure,
  clearAssignedFeeStructureToCalss,
} = assignFeeStructureToClassSlice.actions;

export default assignFeeStructureToClassSlice.reducer;
